import request from '@apps-common/js-client/api/request';
import {useEffect, useState} from 'react';
import {urls} from '../api.js';

function useGet(url) {
  const [state, updateState] = useState({
    loading: !!url,
    error: null,
    data: null,
  });

  useEffect(() => {
    const controller = new AbortController();
    const fetch = () =>
      request
        .get(url, {
          signal: controller.signal,
        })
        .then(response => {
          updateState({
            loading: false,
            error: null,
            data: response.data,
          });
        })
        .catch(error => {
          updateState({
            loading: false,
            error,
            data: null,
          });
        });

    if (url) {
      updateState({
        loading: true,
        error: null,
        data: null,
      });
      fetch();
    } else {
      controller.abort();
      updateState({
        loading: false,
        error: null,
        data: null,
      });
    }

    return () => {
      // cancel previous request.
      updateState({loading: false, error: null, data: null});
      controller.abort();
    };
  }, [url]);

  return state;
}

export function useResult(subscriptionId, resultId) {
  const url =
    subscriptionId && resultId
      ? `${urls.sif}/collections/${subscriptionId}/items/${resultId}`
      : null;
  return useGet(url);
}
